(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shulex-chat-position"] && !Shopify.designMode) return;
  try {
    (() => {
    let launcher;
    let toast;
    let bell;
    let notificationIconWidth = 60;
    let pending;
    const setOffset = (name, value) => {
      const styles = document.documentElement.style;
      if (styles.getPropertyValue(name) !== value) styles.setProperty(name, value);
    };
    const syncPosition = () => {
      pending = null;
      const nextToast = document.querySelector('.pushowl-simple-toast, .pushowl-simple-toas');
      if (toast !== nextToast) {
        if (toast) resizeObserver.unobserve(toast);
        toastObserver.disconnect();
        toast = nextToast;
        if (toast) {
          resizeObserver.observe(toast);
          toastObserver.observe(toast, { attributes: true, subtree: true, attributeFilter: ['class', 'style', 'hidden', 'aria-expanded'] });
        }
      }
      const nextBell = toast?.querySelector('.pushowl-simple-toast__action-buttons .pushowl-bell-button');
      if (bell !== nextBell) {
        if (bell) resizeObserver.unobserve(bell);
        bell = nextBell;
        if (bell) resizeObserver.observe(bell);
      }
      // Limit theme overrides to the small floating icon. Expanded notification
      // content must retain PushOwl's native colors, shape and positioning.
      const notificationRect = toast?.getBoundingClientRect();
      const compact = !!bell && notificationRect.width > 0 && notificationRect.width <= 120
        && notificationRect.height > 0 && notificationRect.height <= 120
        && !toast.querySelector('[aria-expanded="true"]');
      toast?.toggleAttribute('data-engwe-compact', compact);
      if (compact) {
        notificationIconWidth = notificationRect.width;
      }
      if (!launcher) return;
      // The mobile close button sits in the header, not at the floating anchor.
      if (window.matchMedia('(max-width: 767px)').matches && launcher.hasAttribute('data-engwe-chat-open')) return;
      const gap = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--engwe-floating-gap')) || 12;
      const scrollGap = 24;
      const rect = launcher.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      const scrollButton = document.querySelector('.scroll-to-top');
      if (scrollButton) {
        const scrollRect = scrollButton.getBoundingClientRect();
        setOffset('--engwe-scroll-right', `${Math.max(12, window.innerWidth - rect.left - rect.width / 2 - scrollRect.width / 2)}px`);
        setOffset('--engwe-scroll-bottom', `${Math.max(12, window.innerHeight - rect.bottom - scrollGap - scrollRect.height)}px`);
      }
      const viewportTop = window.visualViewport?.offsetTop || 0;
      setOffset('--engwe-chat-frame-bottom', `${Math.max(12, window.innerHeight - rect.top + gap)}px`);
      setOffset('--engwe-chat-frame-right', `${Math.max(12, window.innerWidth - rect.right)}px`);
      setOffset('--engwe-chat-frame-height', `${Math.max(0, rect.top - viewportTop - 24)}px`);
      // Keep the expanded panel anchored to the notification icon's right edge.
      const panelBottom = window.innerHeight - rect.top + gap;
      setOffset('--engwe-pushowl-panel-height', `${Math.max(0, window.innerHeight - viewportTop - panelBottom - 12)}px`);
      const notificationRightShift = window.matchMedia('(min-width: 768px)').matches ? 10 : 0;
      setOffset('--engwe-pushowl-right', `${Math.max(12, window.innerWidth - rect.left - notificationIconWidth) - notificationRightShift}px`);
      setOffset('--engwe-pushowl-bottom', `${Math.max(12, panelBottom)}px`);

    };
    const schedulePosition = () => {
      if (!pending) pending = requestAnimationFrame(syncPosition);
    };
    const resizeObserver = new ResizeObserver(schedulePosition);
    const toastObserver = new MutationObserver(schedulePosition);
    resizeObserver.observe(document.body);
    window.addEventListener('resize', schedulePosition, { passive: true });
    window.visualViewport?.addEventListener('resize', schedulePosition, { passive: true });
    window.visualViewport?.addEventListener('scroll', schedulePosition, { passive: true });
    // The buy bar writes its measured height here, which also moves the launcher.
    new MutationObserver(schedulePosition).observe(document.documentElement, {
      attributes: true, attributeFilter: ['style'],
    });
    const applyPosition = () => {
      const root = document.querySelector('shulex-chatbot-lancher')?.shadowRoot;
      schedulePosition();
      if (!root || root.getElementById('engwe-chat-position')) return;

      const style = document.createElement('style');
      style.id = 'engwe-chat-position';
      // Desktop shares one anchor. Mobile uses a fullscreen frame and header close.
      style.textContent = `
        #livechat_launcher_btn {
          position: fixed !important;
          top: auto !important;
          left: auto !important;
          right: var(--engwe-floating-right, 24px) !important;
          bottom: var(--engwe-chat-bottom, 145px) !important;
          transform: none !important;
          width: 60px !important;
          height: 60px !important;
          background: var(--engwe-floating-accent, #EE731B) !important;
          color: #fff !important;
          border: 0 !important;
          border-radius: 50% !important;
          box-shadow: 0 4px 10px #00000026 !important;
        }
        #shulex-chatbot-frame {
          position: fixed !important;
          top: auto !important;
          left: auto !important;
          right: var(--engwe-chat-frame-right, 24px) !important;
          bottom: var(--engwe-chat-frame-bottom, 217px) !important;
          max-height: var(--engwe-chat-frame-height, calc(100dvh - 229px)) !important;
          min-height: 0 !important;
          max-width: calc(100vw - 32px) !important;
          box-sizing: border-box !important;
          transform: none !important;
        }
        @media (max-width: 767px) {
          #livechat_launcher_btn { right: var(--engwe-floating-right, 16px) !important; }
          #shulex-chatbot-frame {
            inset: 0 !important;
            width: 100% !important;
            height: 100vh !important;
            height: 100dvh !important;
            max-width: none !important;
            max-height: none !important;
            border: 0 !important;
            border-radius: 0 !important;
            z-index: 2147483646 !important;
          }
          /* Fullscreen chat already provides its own header close button. */
          #livechat_launcher_btn[data-engwe-chat-open] {
            display: none !important;
          }
        }
      `;
      root.appendChild(style);

      const syncOpenState = () => {
        const nextLauncher = root.getElementById('livechat_launcher_btn') || root.querySelector('.kpsSIaaRCem2tmmD3wHE');
        if (launcher !== nextLauncher) {
          if (launcher) resizeObserver.unobserve(launcher);
          launcher = nextLauncher;
          if (launcher) resizeObserver.observe(launcher);
        }
        const frame = root.getElementById('shulex-chatbot-frame');
        // Shulex sets this inline for both manual and automatic opening/closing.
        launcher?.toggleAttribute('data-engwe-chat-open', frame?.style.pointerEvents === 'auto');
        schedulePosition();
      };

      syncOpenState();
      new MutationObserver(syncOpenState).observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style'],
      });
    };

    applyPosition();
    new MutationObserver(applyPosition).observe(document.body, { childList: true, subtree: true });
    // Attaching a shadow root does not trigger the document mutation observer.
    let attempts = 0;
    const retry = setInterval(() => {
      applyPosition();
      if (launcher || ++attempts >= 120) clearInterval(retry);
    }, 500);
  })();
  } catch(e) { console.error(e); }
})();

})();
